import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/hu.ts
var add = "Hozzáadás";
var remove = "Eltávolítás";
var removeAll = "Összes eltávolítása";
var incomplete = "Sajnáljuk, nem minden mező lett helyesen kitöltve.";
var submit = "Beküldés";
var noFiles = "Nincs fájl kiválasztva";
var moveUp = "Mozgás felfelé";
var moveDown = "Mozgás lefelé";
var isLoading = "Betöltés...";
var loadMore = "Töltsön be többet";
var next = "Következő";
var prev = "Előző";
var addAllValues = "Adja hozzá az összes értéket";
var addSelectedValues = "Kiválasztott értékek hozzáadása";
var removeAllValues = "Távolítsa el az összes értéket";
var removeSelectedValues = "A kiválasztott értékek eltávolítása";
var chooseDate = "Válassza ki a dátumot";
var changeDate = "Dátum módosítása";
var close = "Bezárás";
var open = "Nyitott";
var accepted = function({
  name
}) {
  return `Fogadja el a ${name} mezőt.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mezőnek ${date(args[0])} után kell lennie.`;
  }
  return `${sentence(name)} mezőnek a jövőben kell lennie.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} csak alfanumerikus karaktereket tartalmazhat.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} csak betűket és számokat tartalmazhat.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} csak betűket és szóközöket tartalmazhat.`;
};
var contains_alpha = function({
  name
}) {
  return `A ${sentence(name)} betűrendes karaktereket kell tartalmaznia.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `A ${sentence(name)} betűket vagy számokat kell tartalmaznia.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `A ${sentence(name)} betűket vagy szóközöket kell tartalmaznia.`;
};
var contains_symbol = function({
  name
}) {
  return `A ${sentence(name)} szimbólumot kell tartalmaznia.`;
};
var contains_uppercase = function({
  name
}) {
  return `A ${sentence(name)} nagybetűt kell tartalmaznia.`;
};
var contains_lowercase = function({
  name
}) {
  return `A ${sentence(name)} kisbetűt kell tartalmaznia.`;
};
var contains_numeric = function({
  name
}) {
  return `A ${sentence(name)} számot kell tartalmaznia.`;
};
var symbol = function({
  name
}) {
  return `A ${sentence(name)} szimbólumnak kell lennie.`;
};
var uppercase = function({
  name
}) {
  return `A ${sentence(name)} csak nagybetűket tartalmazhat.`;
};
var lowercase = function({
  name
}) {
  return `A ${sentence(name)} csak kisbetűket tartalmazhat.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} mezőnek ${date(args[0])} előtt kell lennie.`;
  }
  return `${sentence(name)} mezőnek a múltban kell lennie.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Ez a mező hibásan lett konfigurálva, így nem lehet beküldeni.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `A ${sentence(name)} mezőnek ${a} és ${b} között kell lennie.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} nem egyezik.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nem érvényes dátum, ${args[0]} formátumot használj`;
  }
  return "Ez a mező hibásan lett konfigurálva, így nem lehet beküldeni.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} mezőnek ${date(args[0])} és ${args[1]} között kell lennie`;
};
var email = "Kérjük, érvényes email címet adjon meg.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} mező nem a kijelölt (${list(args)}) módon ér véget.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} nem engedélyezett érték.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} mezőnek legalább egy karakteresnek kell lennie.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} mezőnek maximum ${max2} karakteresnek kell lennie.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ${max2} karakter hosszúnak kell lennie.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} mezőnek minimum ${min2} karakteresnek kell lennie.`;
  }
  return `${sentence(name)} mezőnek ${min2} és ${max2} karakter között kell lennie.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nem engedélyezett érték.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nem lehet több mint ${args[0]} ${name}.`;
  }
  return `${sentence(name)} nem lehet nagyobb, mint ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Nincsenek támogatott fájlformátumok.";
  }
  return `${sentence(name)}-nak/nek a következőnek kell lennie: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nem lehet kevesebb, mint ${args[0]} ${name}.`;
  }
  return `${sentence(name)}-nak/nek minimum ${args[0]}-nak/nek kell lennie.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" nem engedélyezett ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} mezőnek számnak kell lennie.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" vagy ")} szükséges.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} mező kötelező.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} nem a következővel kezdődik: ${list(args)}.`;
};
var url = function() {
  return `Kérjük, adjon meg egy érvényes URL-t.`;
};
var invalidDate = "A kiválasztott dátum érvénytelen.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var hu_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, hu_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=hu.mjs.map